// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4196":"93fcb6943d5e3c5b","4740":"359e5e9a752dc27a"}[chunkId] + ".css";
};